import styled from "@emotion/styled";
import theme from "../../styles/theme";
import CTA from "../cta/cta";

export const VideoCtaBase = styled.section`
  margin: 2rem auto;
  padding: 20px;

  ${theme.largerThan.lg} {
    margin: 5rem auto;
  }
`;

export const VideoCtaContainer = styled.div`
  max-width: ${theme.maxWidth};
  margin: 0 auto;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 2rem;

  ${theme.largerThan.lg} {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
`;

export const PrimaryCopy = styled.div`
  text-align: center;
  max-width: 600px;
  margin: 0 auto;

  ${theme.largerThan.lg} {
    text-align: left;
    grid-column: span 2 / span 2;
  }

  p.paragraph {
    margin: 1.5rem 0;
    font-size: ${theme.fontSizes[2]};
    line-height: 1.5;
    font-weight: ${theme.fontWeights.regular};
  }
  ul {
    font-size: ${theme.fontSizes[2]};
    line-height: 1.5;
    font-weight: ${theme.fontWeights.regular};
  }
`;

export const VideoEmbed = styled.div`
  ${theme.largerThan.lg} {
    grid-column: span 4 / span 4;
  }
`;

export const CTAStyled = styled(CTA)`
  width: fit-content;
  align-self: center;
  padding: 12px 16px !important;

  ${theme.largerThan.sm} {
    align-self: initial;
  }
`;

export const VideoIframe = styled.iframe`
  border: none;
  width: 100%;
  height: 100%;

  ${theme.largerThan.md} {
    height: 400px;
  }
`;
